import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer>
        <div id="go-top"><a className="smoothscroll" title="Up to the top" href="#home"><i className="icon-up-open"></i></a></div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js